// Projects Data
export const projects = [
  {
    title: "Expenso",
    subtitle: "Track your expenses and settle your payments",
    description:
      "Built in ReactJS. It uses Heap Data Structure and Algorithm for Payment Settlement. It uses D3 & React Chart JS To Show Graphical UI To Improve User Experience.",
    skills: "Built with: React JS, Chart JS",
    image: "./gif-files/expenso.gif",
    link: "https://expenso-app.netlify.app/",
    github: "https://github.com/divyanshrastogi51/Expenso",
  },
  {
    title: "Newsletter Subscription System",
    subtitle: "A web based manage newsletter subscription operations.",
    description:
      "It uses mysql database to effectively manage newsletter subscription operations. It has admin panel where he can add new newsletter and a user can manage which newsletter he wants to subscribe",
    skills: "Built with: Node.js, Express.js, MySQL, HTML, CSS, EJS",
    image: "./gif-files/newsletter.gif",
    link: "",
    github:
      "https://github.com/divyanshrastogi51/newsletter-subscription-system",
  },
  {
    title: "Smart-Agri",
    subtitle: "A IOT project on smart agriculture.",
    description:
      "In this project, I have also tried to apply the concepts of Internet of Things such as cloud computing and RESTful API’s in the form of storage and retrieval of data .",
    skills: "Built with: MERN Stack",
    image: "./gif-files/iot-smart-agri.gif",
    link: "https://github.com/divyanshrastogi51/Smart-Agri-IOT",
    github: "https://github.com/divyanshrastogi51/Smart-Agri-IOT",
  },
  {
    title: "ACM Website",
    subtitle: "Website for Association for Computing Machinery Chapter, LNMIIT",
    description:
      "This website was part of best website competition by ACM. It is designed and developed by Me",
    skills: "Built with: HTML, CSS",
    image: "./gif-files/acm.gif",
    link: "https://divyanshrastogi51.github.io/ACM-Website/",
    github: "https://github.com/divyanshrastogi51/ACM-Website",
  },
  {
    title: "Portfolio",
    subtitle: "My portfolio built in ReactJS",
    description:
      "This is third installment of my website. I made by first website in 2019 using basic html css. and then in 2021 with advance css. This is the latest edition",
    skills: "Built with: React JS, Tailwind CSS",
    image: "./gif-files/portfolio.gif",
    link: "http://divyanshrastogi.com/",
    github: "https://github.com/divyanshrastogi51/",
  },
];

// Skills Data
export const skills = [
  "HTML5",
  "CSS3",
  "JavaScript",
  "React",
  "Node / Express.js",
  "MongoDB / Mongoose",
  "Git & Version Control",
  "C++",
  "Data Strutures & Algorithms",
];

export const myskills = [
  { title: "HTML", name: "html5" },
  { title: "CSS", name: "css3" },
  { title: "JavaScript", name: "js" },
  { title: "Node / Express.js", name: "node js" },
  { title: "React", name: "react" },
  { title: "MongoDB / Mongoose", name: "database" },
  { title: "Git & Version Control", name: "github" },
  { title: "Data Strutures & Algorithms", name: "code" },
];
